const { createMachine } = require("xstate");
const actions = require("./actions");
const guards = require("./guards");
const services = require("./services");

const ViewEditActionPlanMachine = createMachine(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5QDcCWYDuBaSqAuWAhgMZ6oD2AdlgA4A2hlAdKhHWAMQAyA8gIIARANoAGALqJQNcrHwVKkkAA9EWAJwAWDUwCsAZgBsARg0B2DUYBMADiumANCACeqk9aZrLGvXp1G9RiJqagamAL5hjmiYOBD4RKTytAzMdOSEcZRQHHwA4gCiAHIAKky8ggCShbkA+vkASvU89aISSCDSsmRUiioIWAYi2kYGlnpePnoalkY6ji4IIzq6o5aDU5oh1tYRUejYuAQk3dT0jExpGahZOQUlTMU8Ajw1AnzFfDXlAvnC4oqdOQ9dp9LD+UwGJgGDTWIbWLxqUymPRqeauTxMaymEamHRaHSmWx6XYgaIHOJHRJUZLnS6ZbJ5IqlHjVHhVWpvD5ffg-P5tKQyIEKEGuFFGXQ6AxqEQIvSmRFzZyqaFMUwifzTZFqHR+DQGElk2LxY5JM6pdL025MpgAYR4AFkAApcfLFfKvd6fb6-VoAwUnXquDRDJgiETWKUBIzy7x6NEIUKhmxqIzWaYwvTWHQG-ZGyknGnmq43X3tQEBkX9EIiTHGcNDaVI-zx8amJhrER6MPInQiaEabORUm5w4JAtmi4WyAcer5b6lgVdeSB-pGVPaTSjTNBSwhAxxpUITOWJgWEbrHQR6yeHMxUcm6kTunT+f-Mv+5eVsHY8VWAy6zNYRMDR42mZZdzGfcjAVMxwiHQ17ypU4UknDJpwAVUdTl3QAIXyPhZ3qGpHgAaSKBcOg-YFQFBEZtQ8ZF-y0UIsS0eNbBPQxoTxM9ryCW9yWNJDC1QiBp3yAANR1mmKCjy0-GjEECbRCVhGZLF3XtNAcQ8rAjDxxiCTtLCGcMNAEvMx1NFDnwgHIBAEGoADU+C4dD3UeGoADEKi4N0WjfRchRXMFpRrWFRjUNM5V8RUFmjAlMV8UZjDXQZoIsxDxxsqc7Nne0eCc90XLc90vKae1vN8-y5Ko4VFNXa9xVGHRgh8IIplmeNoNxds93VCN9xsQc9jvCkrMfHK0IgJg8HICByA4JyKnyAB1GoWVyNlqhqPgbWKCoWQAZVqpdqOUVRPGWNVET0wJLD8VFdJmGsgisNQUVhcxzEy8aH2Q2lctm+bFuWtaajtJ0XTdXb9sOwoTsCyizvqi6qxM9towCeVbDMbxuqGZYUVu0wTLMHVfqE7LAem4GFo4I6ZNO4KvzsNQoQemZg38Ax4Wsbr4RrXn-18Hx9wHODRsE-NrJpsSZqoKByGubIwfWyHnVdd09oO47mYrBqsB0Sw2zDTN-00YmZm6l7QxTXdPpEb7zPgkc-uEp8gcV5WbjV4inheHX4cR-lkZZw2U3AgkNQd6Egm6rR3H3YxCVxE2TOJV2xqp2Wi3lphvZVhmmaR+TztBUm21CPFr2sKNpQMAWMeF-R9EMKYKaz6WJoBvPICYYhyAAW3oMA8E4P3Nu22og710u6pC429F0E3xm8bZE5A3TvBrSU6IhM21UzqXLP+kTbIH4fR-HpaVvWx5nlh3WEf1hS0aN-wmGgrMO6MkwdPioMdmXgkSXjrsGNM+ou6nw9lNfOg8R7sBvozeosl54oxCjYE84Za59mNlYWKTchYRlbmLDukthzZxlpNOW-diAAAswDEAANYcFfuXVwNhIQH0CB9KUMo9TsW2EwWKvNtSDSgSfLKudRJ0MYSwthRhQ5l1RhXAImJbD7klEiAIT0FjbHcLFH8PV1RIkptQ3usiZoMKYawoQlhlELy-DYdwUVzCIjFmGYwQjDE6lxDzE2gxLDmJ7iJMAAAncJ5BwkzldPUAAmuw1RqgdQ1n8eqXwMoszG3jDYcUap9ARjMv+OukjKHdzPhOMAShpDhLIDcBalAwAsEoMgcgzDmkIXdtTZg1Tan1KgAga4bTiCEBOK0JJK4tAnmNkfPUIheydgWd1fQ2gIHjB1KEB6FCuk5xob0mp0SBkcAiVE8JTAzh4AAGbRKHkwXZFiwmHLqSrIZrTyCjPGeISZlYtDL2gt4KwBIZSGB1PGJeIiYT6AWTCXEIQIhDkoPNOAigHmhLNH6DBrNNDuAiruaKPY4qqB3roeUrcoq6jriEypKFWDsExeHd+V4v64ihXqLEoQDwLCwFMZeD0DCjAjLuGUWjqWwLlirBlBt37BF-L2cwXhbCk0vCslSUV1UaFuvuHY0DpH7KsVKt+tEfAqXSh1fhXhG6HlSiInwsy0yKsMGKnpVi6bkENRw1c6pOI6PGCLFMKJurtxWBMKUt1jbBN1d0mRF9C5ZA9ck-o+42yXnJoEQk0wPpBv3CG7wYbsQRudTGoGCDr5gATSFVM7NK5eB1A7GK2bl5hjrtsFxEIRrlJgS6i+NiWEVq-C1VUH0uzhkzGxa1UUoSSm8I9IpncpHRv1ac6J-bDZrBUp2TQkp9xhmgqqod15tSpixNGDKUa9mWL6UcyV74sUNWmEnAVhhUy+A+vHZ6WYPBBGCLCKFAQoERCAA */
    id: "view-edit-action-plan",

    predictableActionArguments: true,
    context: {
      view: "todo",
      filters: [],
    },
    states: {
      idle: {
        on: {
          LOAD: {
            target: "loading",
            cond: "validLoadRequest",
            actions: ["saveLoadRequest", "spawnFetchAgents"],
          },
        },
      },

      loading: {
        on: {
          "AGENT.LOADING_ERROR": {
            target: "error",
            actions: "unsetDataLoaded",
          },

          "AGENT.TODO_DATA_LOADED": {
            target: "loading",
            internal: true,
            actions: ["saveTodoActions", "setTodoDataLoaded"],
          },

          "AGENT.ONGOING_DATA_LOADED": {
            target: "loading",
            internal: true,
            actions: ["saveOngoingActions", "setOngoingDataLoaded"],
          },

          "AGENT.COMPLETE_DATA_LOADED": {
            target: "loading",
            internal: true,
            actions: ["saveCompleteActions", "setCompleteDataLoaded"],
          },
        },

        entry: "sendLoadRequestToFetchAgents",

        always: {
          target: "loaded",
          cond: "allDataLoaded",
          actions: [
            "unsetDataLoaded",
            "updateLastRefreshedTimestamp",
            "saveUniqueFiltersOptions",
            "filterTodoActions",
            "filterOngoingActions",
            "filterCompleteActions",
          ],
        },
      },

      loaded: {
        on: {
          RELOAD: "loading",

          LOAD: {
            target: "loading",
            cond: "validLoadRequest",
            actions: ["saveLoadRequest"],
          },

          UPDATE_BEARER_TOKEN: {
            target: "loaded",
            internal: true,
            cond: "validToken",
            actions: "saveToken",
          },

          EXPORT: {
            target: "exporting",
            actions: "combineAndSortCorrectiveActions",
          },

          ADD_VALUE_TO_FILTER: {
            target: "loaded",

            actions: [
              "addValueToFilter",
              "filterTodoActions",
              "filterOngoingActions",
              "filterCompleteActions",
            ],

            internal: true,
          },

          REMOVE_VALUE_FROM_FILTER: {
            target: "loaded",

            actions: [
              "removeValueFromFilter",
              "filterTodoActions",
              "filterOngoingActions",
              "filterCompleteActions",
            ],

            internal: true,
          },
        },

        states: {
          todo: {
            on: {
              VIEW_ONGOING_ACTIONS: {
                target: "ongoing",
                actions: [
                  "setViewToOngoing",
                  "setCorrectiveActionsToFilteredOngoingActions",
                  "sortCorrectiveActions",
                ],
              },

              VIEW_COMPLETE_ACTIONS: {
                target: "complete",
                actions: [
                  "setViewToComplete",
                  "setCorrectiveActionsToFilteredCompleteActions",
                  "sortCorrectiveActions",
                ],
              },

              SORT: {
                target: "todo",
                internal: true,
                cond: "correctiveActionsNotEmpty",
                actions: "sortCorrectiveActions",
              },
            },
          },

          ongoing: {
            on: {
              VIEW_COMPLETE_ACTIONS: {
                target: "complete",
                actions: [
                  "setViewToComplete",
                  "setCorrectiveActionsToFilteredCompleteActions",
                  "sortCorrectiveActions",
                ],
              },
              VIEW_TODO_ACTIONS: {
                target: "todo",
                actions: [
                  "setViewToTodo",
                  "setCorrectiveActionsToFilteredTodoActions",
                  "sortCorrectiveActions",
                ],
              },

              SORT: {
                target: "ongoing",
                internal: true,
                cond: "correctiveActionsNotEmpty",
                actions: "sortCorrectiveActions",
              },
            },
          },

          complete: {
            on: {
              VIEW_ONGOING_ACTIONS: {
                target: "ongoing",
                actions: [
                  "setViewToOngoing",
                  "setCorrectiveActionsToFilteredOngoingActions",
                  "sortCorrectiveActions",
                ],
              },
              VIEW_TODO_ACTIONS: {
                target: "todo",
                actions: [
                  "setViewToTodo",
                  "setCorrectiveActionsToFilteredTodoActions",
                  "sortCorrectiveActions",
                ],
              },

              SORT: {
                target: "complete",
                internal: true,
                cond: "correctiveActionsNotEmpty",
                actions: "sortCorrectiveActions",
              },
            },
          },

          check: {
            always: [
              {
                target: "todo",
                cond: "todoViewActive",
                actions: [
                  "setViewToTodo",
                  "setCorrectiveActionsToFilteredTodoActions",
                  "sortCorrectiveActions",
                ],
              },
              {
                target: "ongoing",
                cond: "ongoingViewActive",
                actions: [
                  "setViewToOngoing",
                  "setCorrectiveActionsToFilteredOngoingActions",
                  "sortCorrectiveActions",
                ],
              },
              {
                target: "complete",
                cond: "completeViewActive",
                actions: [
                  "setViewToComplete",
                  "setCorrectiveActionsToFilteredCompleteActions",
                  "sortCorrectiveActions",
                ],
              },
            ],
          },
        },

        initial: "check",
      },

      error: {
        on: {
          RETRY: "loading",
        },

        entry: "saveError",
      },

      exporting: {
        invoke: {
          src: "exportCorrectiveActions",
          onDone: "loaded",
          onError: "error",
        },
      },
    },

    initial: "idle",
  },
  {
    actions: actions,
    guards: guards,
    services: services,
  },
);

export { ViewEditActionPlanMachine };
